const c = {
  name: "NetworkFix",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,24.2c1.8-1,3-3,3-5.2c0-2.4-1.4-4.5-3.5-5.4c-0.6-0.3-1.3-0.5-2-0.5v5c0,0.3-0.2,0.5-0.5,0.5
			c-0.3,0-0.5-0.2-0.5-0.5v-5c-0.7,0.1-1.4,0.2-2,0.5c-2.1,0.9-3.5,3-3.5,5.4c0,2.2,1.2,4.2,3,5.2V27h2v-4.1c-0.8-0.2-1.5-0.6-2-1.2
			c-0.6-0.7-1-1.6-1-2.6c0-1.3,0.6-2.4,1.5-3.1V18c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-2.1c0.9,0.7,1.5,1.9,1.5,3.1
			c0,1-0.4,1.9-1,2.6c-0.5,0.6-1.2,1-2,1.2V27h2V24.2z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-9,20-20,20C9,40,0,31,0,20z M2,19h7c0.1-2.9,0.5-5.6,1.1-8H4.4
			C3,13.4,2.2,16.1,2,19z M10.8,9C11.1,8,11.6,7,12,6.1c0.6-1.2,1.3-2.2,2.1-3.1C10.8,4.1,7.9,6.3,5.7,9H10.8z M11,20
			c0,3.3,0.5,6.4,1.2,9.1h15.5c0.8-2.7,1.2-5.7,1.2-9.1c0-3.3-0.4-6.3-1.2-8.9H12.2C11.4,13.7,11,16.7,11,20z M10.2,29
			c-0.7-2.4-1.1-5.1-1.2-8H2c0.2,2.9,1,5.6,2.4,8H10.2z M5.8,31c2.1,2.7,5,4.8,8.4,6c-0.8-0.9-1.5-2-2.1-3.1
			c-0.5-0.9-0.9-1.8-1.2-2.8H5.8z M27.1,31H21v6.8c1.9-0.4,3.7-2.1,5.2-4.9C26.5,32.4,26.8,31.7,27.1,31z M13.8,33
			c1.5,2.8,3.3,4.5,5.2,4.9V31h-6.1C13.2,31.7,13.5,32.4,13.8,33z M29.2,31c-0.4,1-0.8,2-1.2,2.8c-0.6,1.2-1.3,2.2-2.1,3.1
			c3.3-1.1,6.3-3.3,8.4-6H29.2z M35.6,29c1.4-2.4,2.2-5.1,2.4-8h-7c-0.1,2.9-0.5,5.6-1.2,8H35.6z M35.6,11h-5.8
			c0.7,2.4,1.1,5.1,1.1,8h7C37.8,16.1,37,13.4,35.6,11z M13.8,7c-0.3,0.6-0.6,1.3-0.9,2H19V2.1C17.1,2.6,15.3,4.2,13.8,7z M21,2.1V9
			h6.1c-0.3-0.7-0.6-1.4-0.9-2C24.7,4.2,22.9,2.6,21,2.1z M29.2,9h5c-2.1-2.8-5.1-4.9-8.5-6.1c0.8,0.9,1.5,2,2.1,3.1
			C28.4,7,28.9,8,29.2,9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as NetworkFix
};
